import { SearchConsoleUrlInspection } from '@/modules/DomainsApi';
import { Typography } from 'antd';
import { FC } from 'react';

interface Props {
  canonical:
    | NonNullable<SearchConsoleUrlInspection['indexStatusResult']>['userCanonical']
    | NonNullable<SearchConsoleUrlInspection['indexStatusResult']>['googleCanonical']
    | null;
}

export const CanonicalLabel: FC<Props> = ({ canonical }) => {
  if (canonical) {
    return (
      <span>{ canonical }</span>
    );
  } else {
    return <Typography.Text>(недоступно)</Typography.Text>;
  }
};
